import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// استورد BrowserRouter و SettingsProvider
import { BrowserRouter } from 'react-router-dom';
import { SettingsProvider } from './contexts/SettingsContext';

// استيراد MUI ThemeProvider و CssBaseline
import { ThemeProvider, CssBaseline } from '@mui/material';
import theme from './theme'; // ملف الثيم الجديد

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <SettingsProvider>
      <ThemeProvider theme={theme}>
        <CssBaseline /> {/* لضبط الأساسيات مثل margin و padding و background */}
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </ThemeProvider>
    </SettingsProvider>
  </React.StrictMode>
);
